import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aee1f956"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "records-card" }
const _hoisted_2 = { class: "record-type" }
const _hoisted_3 = { class: "record-value" }
const _hoisted_4 = { class: "record-date" }

import { toRefs } from 'vue'

  import { IRecordsBySports } from '@/types/workouts'

  interface Props {
    records: IRecordsBySports
    sportTranslatedLabel: string
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    records: null,
    sportTranslatedLabel: null
  },
  setup(__props: any) {

const props = __props as {
    records: IRecordsBySports
    sportTranslatedLabel: string
  }

  

  const { records, sportTranslatedLabel } = toRefs(props)

return (_ctx: any,_cache: any) => {
  const _component_SportImage = _resolveComponent("SportImage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createVNode(_component_SportImage, {
          "sport-label": _unref(records).label,
          color: _unref(records).color
        }, null, 8, ["sport-label", "color"]),
        _createTextVNode(" " + _toDisplayString(_unref(sportTranslatedLabel)), 1)
      ]),
      content: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(records).records, (record) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "record",
            key: record.id
          }, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t(`workouts.RECORD_${record.record_type}`)), 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(record.value), 1),
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: {
                name: 'Workout',
                params: { workoutId: record.workout_id },
              }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(record.workout_date), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})